import * as go from "gojs";

// Images
import editButtonImage from "../../assets/images/goJs/edit_button_white.png";
import addButtonImageWhite from "../../assets/images/goJs/add_button_white.png";
import lessButtonImageWhite from "../../assets/images/goJs/less_button_white.png";

import icon from "../../assets/images/goJs/icon_division.png";

const $ = go.GraphObject.make;

const categoryItem = (diagram, editButtonClick, nodeStyle, makePort, colors, titleStyle,
collapseButtonClick, avoidNodeOverlap) => {
  return diagram.nodeTemplateMap.add(
    "Division", // Avoid to default category
$(
      go.Node,
      "Table",
      nodeStyle(),
      new go.Binding("location", "loc", go.Point.parse).makeTwoWay(go.Point.stringify),
      new go.Binding("visible", "isVisible", function(isVisible) {
        // return isVibisible !== false;
        return isVisible !== false; // true - false
      }),
      $(
        go.Shape,
        "RoundedRectangle",
        {
          name: "Default shape",
          fill: colors.blueLighter,
          strokeWidth: 0,
          alignment: go.Spot.TopRight,
        },
        new go.Binding("desiredSize", "isPalette", (isPalette) =>
          isPalette ? new go.Size(222, 40) : new go.Size(224, 86)
        )
      ),
      $(
        go.Panel,
        "Horizontal",
        {
          width: 208,
          // margin: new go.Margin(20, 8, 0, 8),
        },
        new go.Binding("margin", "isPalette", (isPalette) =>
          isPalette ? new go.Margin(2, 8, 0, 8) : new go.Margin(20, 8, 0, 8)
        ),
        new go.Binding("height", "isPalette", (isPalette) => (isPalette ? 24 : 48)),
        $(
          go.Panel,
          "Vertical",
          {
            margin: new go.Margin(10, 8, 0, 8),
          },
          $(go.TextBlock, titleStyle(),new go.Binding("font", "isPalette", (isPalette) => (isPalette ? "14px Averta-Regular" : "14px Averta-Bold")), new go.Binding("text", "title")),
          new go.Binding("height", "isPalette", (isPalette) => (isPalette ? 24 : 48))
        )
      ),
      $(
        go.Panel,
        "Position",
        {
          alignment: go.Spot.TopRight,
        },
        new go.Binding("width", "isPalette", (isPalette) => (isPalette ? 0 : 212)),
        new go.Binding("height", "isPalette", (isPalette) => (isPalette ? 0 : 48)),
        new go.Binding("margin", "isPalette", (isPalette) =>
          isPalette ? new go.Margin(0, 8, 0, 0) : new go.Margin(8, 8, 0, 0)
        ),
        $(
          go.Panel,
          "Button",
          {
            name: "Edit button",
            position: new go.Point(188, 0),
            width: 24,
            height: 24,
            cursor: "pointer",
            click: editButtonClick,
          },
          $(go.Picture, editButtonImage, {
            width: 24,
            height: 24,
          })
        ),
        // Button to expand/collapse the node
        $(
          go.Panel,
          "Button",
          {
            name: "CollapseButton",
            position: new go.Point(156, 0), // Esquina superior izquierda
            width: 24,
            height: 24,
            cursor: "pointer",
            click: collapseButtonClick,
          },
          $(
            go.Picture,
            addButtonImageWhite,
            {
              width: 24,
              height: 24,
            },
            new go.Binding("visible", "childrenExpanded", function (childrenExpanded) {
              return childrenExpanded === false;
            }),
          ),
          $(
            go.Picture,
            lessButtonImageWhite,
            {
              width: 24,
              height: 24,
            },
            new go.Binding("visible", "childrenExpanded", function (childrenExpanded) {
              return childrenExpanded !== false;
            }),
          ),
        ),
        // Children counter
        $(
          go.Panel,
          "Auto",
          {
            position: new go.Point(124, 0),
            width: 24,
          },
            new go.Binding("visible", "childrenAmount", function (
              childrenAmount,
            ) {
              return childrenAmount !== undefined && childrenAmount > 0;
            }),
          $(
            go.Shape,
            "Ellipse",
            {
              position: new go.Point(-5, 0),
              fill: "#fff",
              stroke: null,
              width: 23,
              height: 23,
            },
            new go.Binding("visible", "childrenAmount", function (
              childrenAmount,
            ) {
              return childrenAmount !== undefined && childrenAmount > 0;
            }),
          ),
          $(
            go.Panel,
            "Spot",
            {
              width: 24,
              height: 24,
              alignment: go.Spot.Center,
            },
            new go.Binding("visible", "childrenAmount", function (
              childrenAmount,
            ) {
              return childrenAmount !== undefined && childrenAmount > 0;
            }),
            $(
              go.TextBlock,
              titleStyle(),
              {
                name: "ChildrenAmountText",
                stroke: "#80abba",
                textAlign: "center",
                verticalAlignment: go.Spot.Center,
                height: 24,
                margin: new go.Margin(1, 0, 0, 0),
              },
              new go.Binding("text", "childrenAmount"),
            ),
          ),
        ),
        // @Children counter
      ),
      { dragComputation: avoidNodeOverlap },
      // four named ports, one on each side:
      makePort("T", go.Spot.Top, go.Spot.TopSide, true, true),
      makePort("L", go.Spot.Left, go.Spot.LeftSide, true, true),
      makePort("R", go.Spot.Right, go.Spot.RightSide, true, true),
      makePort("B", go.Spot.Bottom, go.Spot.BottomSide, true, true)
    )
  );
};

export default categoryItem;
